import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { customerservice } from "../../../config";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { CloudUpload } from "@mui/icons-material";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import GroupForm from "./form";
const base_url = customerservice.uri;
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Register Customer page, where you can manage new Customers before approving them.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Customers by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Customer.",
    placement: "right",
  },
   {
    target: ".edit-action",
    content: "Click this button to edit the Customer's Details.",
  },
  {
    target: ".view-customer-360-action",
    content: "Click this button to view the customer details place any attached images.",
  },
   {
    target: ".view-details-action",
    content: "Click this button to add or view customer's details like Next of kin, Guarantors, business detais and you can also find the customers loan data and bio data as well as collateral details.",
  },
     {
    target: ".map-to-employer-action",
    content: "Click this button to map the customer to an employer who will be added through the setups manaement module.",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each Customer from this dropdown.",
    placement: "left",
  },
];

const ignoreFields = [
  "Id",
  "FieldOfficerId",
  "ServicedLoans",
  "RegFeePaid",
  "AccountBalance",
  "InActiveOLB",
  "MeetingDay",
  "MeetingTime",
  "SMSReminder",
  "BranchId",
  "RegionId",
  "CompanyId",
  "OverrideDoneBy",
  "LimitOverrideDate",
  "IsApproved",
  "ApprovedBy",
  "UnapprovedBy",
  "DeletedBy",
  "MigratedBy",
  "MigratedDate"
];



const actions = {
  entity: "Groups",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "groupIds", // Specify the model name here
    inputObjectName: "bulkActivateDeactivateGroups",
  },
  ManageGroup: {
    key: "MANAGEGROUP",
    button_name: "Manage Group",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4, 5],
  },
  dataObject: {
    ignoreFields,
    objectName: "allGroups",
    parameters: null,
  },
  showMore: {
    objectname: "groupsByColumnValues",
    inputsubobjectname: "group",
    parameters: "phoneNumber",
    search: true,
  },
};
function GroupsJson() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Group(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTableForJson
        title="Groups"
        subtitle="View all Groups, create edit or view details"      
        FormComponent={GroupForm}       
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
}

export default GroupsJson;